
import { defineComponent } from 'vue';

export default defineComponent({
  computed: {
    skinColor(): string {
      return `#${this.$route.query.skin}`;
    },
    hair(): string {
      return `${this.$route.query.hair}`;
    },
    hairColor(): string {
      return `#${this.$route.query.hairColor}`;
    },
    eyes(): string {
      return `${this.$route.query.eyes}`;
    },
    eyesColor(): string {
      return `#${this.$route.query.eyesColor}`;
    },
    nose(): string {
      return `${this.$route.query.nose}`;
    },
    mouth(): string {
      return `${this.$route.query.mouth}`;
    },
    blush(): string {
      return `${this.$route.query.blush}`;
    },
    backgroundColor(): string {
      return `#${this.$route.query.background}`;
    },
    clothes(): string {
      return `${this.$route.query.clothes}`;
    }
  }
});
